import { Slider as SliderCore, SliderDrag, SliderItem, SliderDots } from '@studiometa/ui';

/**
 * Slider component
 */
export class Slider extends SliderCore {
  /**
   * Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderDrag,
      SliderItem,
      SliderDots,
    },
    options: {
      duration: {
        type: Number,
        default: 3000,
      },
    },
  };

  timeout = null;
  direction = 'next';

  /**
   * Mounted
   */
  mounted() {
    if (this.$options.duration) {
      this.timeout = setTimeout(this.onTimeout.bind(this), this.$options.duration);
    }
    super.mounted();
  }

  /**
   * On timeout
   */
  onTimeout() {
    if (this.direction === 'next' && this.currentIndex + 1 > this.indexMax) {
      this.direction = 'prev';
    }

    if (this.direction === 'prev' && this.currentIndex - 1 < 0) {
      this.direction = 'next';
    }

    if (this.direction === 'next') {
      this.goNext();
    } else {
      this.goPrev();
    }
  }

  /**
   * On goto
   */
  onGoto() {
    if (this.$options.duration) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.onTimeout.bind(this), this.$options.duration);
    }
  }
}
